export default "__VITE_ASSET__DOv_cWAA__"